<!--<section *ngIf="openTerms" class="relative flex justify-center items-center h-screen"> -->
<!--INSTEAD FOR NOW-->
<section class="relative flex justify-center items-center h-screen">
  <div class="fixed inset-0 flex justify-center items-center h-screen w-full">
    <!-- Container "Entire Box" -->
    <div
      class="flex flex-col border border-gray-200 bg-white fixed z-50 rounded-lg px-10 pt-12 w-[90%] max-w-[800px] h-[550px] shadow-xl"
    >
      <!-- Title -->
      <h2 class="text-[1.75em] mb-4 font-bold ml-3 text-[#141f58] font-sans">
        Rivedi e accetta i Termini e le Condizioni
      </h2>

      <!-- ul for bootstrap tab -->
      <ul
        class="flex border-b border-gray-200 text-base"
        id="LangTab"
        role="tablist"
      >
        <li class="mr-1" role="presentation" (click)="changeTab('italiano')">
          <a
            class="inline-block px-4 py-2 text-sm rounded-t-lg cursor-pointer"
            [class.text-dimot-2]="activeTab === 'italiano'"
            [class.text-gray-300]="activeTab !== 'italiano'"
            [class.border-b-2]="activeTab === 'italiano'"
            [class.border-dimot-2]="activeTab === 'italiano'"
            id="italiano-tab"
            data-toggle="tab"
            role="tab"
            aria-controls="italiano"
            aria-selected="activeTab === 'italiano'"
            >Italiano</a
          >
        </li>
        <li class="mr-1" role="presentation" (click)="changeTab('english')">
          <a
            class="inline-block px-4 py-2 text-sm rounded-t-lg cursor-pointer"
            [class.text-dimot-2]="activeTab === 'english'"
            [class.text-gray-300]="activeTab !== 'english'"
            [class.border-b-2]="activeTab === 'english'"
            [class.border-dimot-2]="activeTab === 'english'"
            id="english-tab"
            data-toggle="tab"
            role="tab"
            aria-controls="english"
            aria-selected="activeTab === 'english'"
            >English</a
          >
        </li>
      </ul>

      <div
        #Scroll
        class="flex flex-col overflow-y-scroll mt-4 pr-8 h-[220px] tab-content scrollbar"
        (scroll)="onScroll($event)"
      >
        <!-- Content of Italiano -->
        <div
          id="italiano"
          role="tabpanel"
          aria-labelledby="italiano-tab"
          [class.hidden]="activeTab !== 'italiano'"
        >
          <h3 class="text-[1.2em] my-1 text-dimot-1">Termini e Condizioni</h3>
          <p><strong>Data di Entrata in Vigore:</strong> 25/03/2025</p>
          <p>
            Il sito presente al link
            <a href="https://dimotma.com/" target="_blank"
              >https://dimotma.com/</a
            >
            (di seguito il &ldquo;Sito&rdquo;) e la piattaforma (di seguito la
            &ldquo;Piattaforma&rdquo;), a cui si accede tramite l&rsquo;area
            riservata dello stesso, sono di propriet&agrave; esclusiva di Dimot
            Ma S.r.l., con sede legale in Roma (RM) Lungotevere De&rsquo; Cenci
            10, 00186 P.IVA 17609241009 (nel seguito, &ldquo;Dimot&rdquo; o la
            &ldquo;Societ&agrave;&rdquo;).
          </p>

          <h5>1. Accettazione dei Termini</h5>
          <p>
            Chiunque acceda o utilizzi i Servizi (di seguito
            l&rsquo;&ldquo;Utente&rdquo;), conferma di avere la capacit&agrave;
            legale nella propria giurisdizione e accetta l&rsquo;utilizzo delle
            presenti Condizioni di Utilizzo. In caso di disaccordo rispetto a
            quanto statuito nelle Condizioni di Utilizzo o successive modifiche
            delle stesse, ovvero nel caso di insoddisfazione per i Servizi
            offerti da Dimot, l&rsquo;Utente ha la facolt&agrave;,
            rispettivamente, di non accettare le presenti Condizioni di Utilizzo
            e rinunciare all&rsquo;impiego dei Servizi offerti dalla
            Piattaforma.
          </p>

          <h5>2. Descrizione dei Servizi</h5>
          <p>
            I Servizi di Dimot offrono soluzioni di semplificazione per la
            visualizzazione e gestione dei dati relativi al &ldquo;market
            access&rdquo; delle societ&agrave; che operano nell&rsquo;ambito
            dell&rsquo;industria delle scienze della vita (di seguito i
            &ldquo;Clienti&rdquo;). I Servizi sono accessibili tramite la
            Piattaforma e la portata e le funzionalit&agrave; dei suddetti
            Servizi possono essere aggiornate o modificate periodicamente a
            esclusiva discrezione della Societ&agrave;.
          </p>

          <h5>3. Funzionamento Piattaforma</h5>
          <p>
            I Servizi di Dimot sono usufruibili tramite l&rsquo;accesso alla
            Piattaforma presente nell&rsquo;area riservata. L&rsquo;accesso alla
            Piattaforma da parte dell&rsquo;Utente &egrave; consentito tramite
            l&rsquo;inserimento delle credenziali di accesso nell&rsquo;apposita
            schermata del Sito. Le credenziali di accesso sono costituite dal
            nome utente e da una password, entrambi forniti da Dimot. A seguito
            del primo accesso, l&rsquo;Utente ha l&rsquo;obbligo di modificare
            la password precedentemente fornita dalla Societ&agrave;. Resta
            inteso che l&rsquo;Utente &egrave; responsabile della salvaguardia
            delle credenziali di accesso e di tutte le attivit&agrave; svolte
            con il proprio account.
          </p>
          <p>
            Per gli accessi successivi, verr&agrave; implementata una procedura
            di Autenticazione a pi&ugrave; fattori (MFA). Per accedere alla
            Piattaforma, l&rsquo;Utente dovr&agrave; inserire una Password
            Monouso (OTP) inviata all&rsquo;indirizzo email registrato.
          </p>
          <p>
            L&rsquo;Utente &egrave; tenuto a informare tempestivamente Dimot di
            qualsiasi accesso non autorizzato al proprio account o di eventuali
            violazioni della sicurezza e, in ogni caso, tale comunicazione
            dovr&agrave; avvenire entro e non oltre 48 (quarantotto) ore dal
            momento in cui si verifica la violazione dell&rsquo;account.
          </p>
          <p>
            Ciascuna utenza &egrave; identificata dal nome utente e dal ruolo
            ricoperto dallo stesso all&rsquo;interno della societ&agrave;
            Cliente (di seguito &ldquo;Utenza&rdquo;), permettendo
            l&rsquo;utilizzo dei Servizi sulla base della posizione ricoperta.
          </p>
          <p>
            La Piattaforma fornisce all&rsquo;Utente informazioni circa lo stato
            di accesso al mercato di un farmaco su base nazionale (di seguito il
            &ldquo;Prodotto&rdquo;) all&rsquo;interno della dashboard nazionale
            dedicata (di seguito la &ldquo;Dashboard&rdquo;). L&rsquo;aggiunta
            di uno o pi&ugrave; Prodotti pu&ograve; essere realizzata solo da
            Dimot.
          </p>
          <p>
            Le informazioni visualizzate sulla Dashboard derivano dai dati
            caricati da ciascun Utente sulla Piattaforma (di seguito i
            &ldquo;Contenuti&rdquo;).
          </p>

          <h5>4. Licenza per l&rsquo;Utilizzo dei Servizi</h5>
          <p>
            <strong>Concessione di Licenza:</strong> Dimot concede al Cliente e
            all&rsquo;Utente una licenza di utilizzo dei Servizi limitata, non
            esclusiva, non trasferibile e revocabile, per i soli scopi
            aziendali, e nel rispetto delle presenti Condizioni di Utilizzo.
          </p>
          <p><strong>Restrizioni:</strong> non &egrave; consentito:</p>
          <ul class="listStyle">
            <li>Decodificare, decompilare o disassemblare il software.</li>
            <li>Utilizzare i Servizi per scopi illegali o non autorizzati.</li>
            <li>
              Modificare, distribuire o creare opere tecnologiche derivate dai
              Servizi senza il nostro previo consenso scritto.
            </li>
          </ul>
          <p>
            Ogni eventuale personalizzazione dei Servizi deve essere richiesta
            per iscritto a Dimot, il quale &egrave; l&rsquo;unico soggetto atto
            alla modifica del software alla base della Piattaforma.
          </p>

          <h5>5. Pagamenti</h5>
          <p>
            <strong>Tariffe:</strong> L&rsquo;accesso alla Piattaforma e ai
            Servizi di Dimot &egrave; soggetto al pagamento di una fee iniziale
            per &ldquo;Set up &amp; Onboarding&rdquo; (di seguito &ldquo;Fee
            Iniziale&rdquo;) variabile a seconda del numero di Utenze che il
            Cliente intende abilitare e il numero di Prodotti per i quali il
            Cliente intende visualizzare le Dashboard. I dettagli sui prezzi e
            sulla fatturazione saranno presentati al momento dell&rsquo;acquisto
            dei Servizi e trasmessi al Cliente sulla base delle informazioni da
            quest&rsquo;ultimo comunicate alla Societ&agrave;.
          </p>
          <p>
            <strong>Fatturazione:</strong> Fornendo i dettagli di pagamento, il
            Cliente autorizza Dimot ad addebitare le tariffe applicabili con
            cadenza mensile entro 30 (trenta) giorni dall&rsquo;emissione delle
            fatture.
          </p>

          <h5>6. Propriet&agrave; Intellettuale</h5>
          <p>
            <strong>Propriet&agrave;:</strong> Tutti i contenuti, marchi e
            propriet&agrave; intellettuali associati ai Servizi sono di
            propriet&agrave; esclusiva di Dimot MA S.r.l.
          </p>
          <p>
            <strong>Contenuti dell&rsquo;Utente:</strong> l&rsquo;Utente
            dichiara di disporre pienamente e legittimamente di tutti i diritti
            relativi ai Contenuti (a titolo esemplificativo ma non esaustivo:
            diritti d&rsquo;autore, diritti di immagine e/o della
            personalit&agrave; in genere, diritti di marchio ed altri diritti di
            privativa, diritti di tutela della riservatezza, diritti relativi al
            ritratto ecc.) caricati sulla Piattaforma della Societ&agrave;.
          </p>
          <p>
            L&rsquo;Utente dichiara espressamente che laddove egli non sia
            pienamente titolare dei diritti sui Contenuti che procede a caricare
            sulla Piattaforma, &egrave; stato espressamente autorizzato a
            disporre dei Contenuti dai terzi titolari dei suddetti diritti ed
            &egrave; dunque pienamente legittimato a rilasciare
            l&rsquo;autorizzazione per l&rsquo;utilizzo dei Contenuti.
          </p>
          <p>
            L&rsquo;Utente si impegna a non pubblicare i Contenuti qualora tale
            Contenuto e/o il suo utilizzo:
          </p>
          <ul class="listStyle">
            <li>
              sia falso, osceno, pornografico, diffamatorio, od include
              informazioni razziste, violente, offensive, moleste, od istiga a
              commettere reati o &egrave; comunque illegale in Italia o nel
              luogo in cui l&rsquo;Utente usa i Servizi od in base ad altre
              leggi comunque applicabili;
            </li>
            <li>
              viola le norme in materia di trattamento dei dati personali o in
              materia di tutela del segreto industriale e delle informazioni
              riservate;
            </li>
            <li>
              presuppone il possesso in capo all&rsquo;Utente di autorizzazioni,
              diritti o requisiti richiesti dalla legge di cui questi non
              dispone;
            </li>
            <li>
              viola brevetti, marchi, diritti d&rsquo;autore od altro diritto di
              terzi;
            </li>
            <li>
              contiene virus informatici o qualsiasi programma o software
              progettato per interrompere, distruggere, danneggiare od anche
              solo limitare le funzionalit&agrave; di qualsiasi software,
              hardware od apparato di rete o dei Servizi o del Sito stessi;
            </li>
          </ul>
          <p>
            L&rsquo;Utente accetta di concedere a Dimot una licenza mondiale,
            priva di royalty, per l&rsquo;utilizzo, la visualizzazione e la
            distribuzione dei Contenuti per finalit&agrave; operative della
            Societ&agrave;.
          </p>

          <h5>7. Privacy dei Dati</h5>
          <p>
            L&rsquo;Utente dichiara di avere preso visione della Informativa
            sulla Privacy di DIMOT, cos&igrave; come modificata di volta in
            volta; tale Informativa disciplina l&rsquo;acquisizione e
            l&rsquo;utilizzo da parte della Societ&agrave; dei Dati personali
            degli Utenti e dei Contenuti.
          </p>

          <h5>8. Attivit&agrave; Vietate</h5>
          <p>
            L&rsquo;Utente garantisce ed accetta di non porre in essere alcuna
            delle attivit&agrave; di seguito elencate:
          </p>
          <ul class="listStyle">
            <li>
              violare leggi o regolamenti durante l&rsquo;utilizzo dei Servizi.
            </li>
            <li>introdurre codici dannosi come virus o malware.</li>
            <li>
              interferire con il funzionamento, l&rsquo;integrit&agrave; o le
              prestazioni dei Servizi.
            </li>
            <li>falsificare la propria identit&agrave; o affiliazione.</li>
          </ul>

          <h5>9. Servizi di Terze Parti</h5>
          <p>
            I Servizi di Dimot possono includere o interagire con servizi di
            terze parti. La Societ&agrave; non assume alcuna
            responsabilit&agrave; in merito alla disponibilit&agrave;,
            accuratezza, legalit&agrave;, sicurezza, contenuti o pratiche di
            tali servizi di terze parti. La Societ&agrave; non approva n&eacute;
            garantisce alcun servizio di terze parti, e l&rsquo;Utente riconosce
            che qualsiasi accesso, interazione o utilizzo di tali servizi
            avviene interamente a proprio rischio. L&rsquo;utilizzo dei servizi
            di terze parti &egrave; regolato esclusivamente dai relativi termini
            e condizioni, e la Societ&agrave; non potr&agrave; essere ritenuta
            responsabile per eventuali danni, perdite o problematiche derivanti
            da tale utilizzo.
          </p>

          <h5>10. Esclusione di Responsabilit&agrave;</h5>
          <p>
            In nessun caso Dimot potr&agrave; essere ritenuto responsabile per
            danni a terzi o alle parti contraenti risultanti, direttamente o
            indirettamente, dall&rsquo;uso della Piattaforma o del Servizio, o
            risultanti da qualsiasi contratto intervenuto tra il Cliente,
            l&rsquo;Utente e terzi. Tale esclusione di responsabilit&agrave;
            riguarda, tra gli altri, danni diretti, indiretti, accidentali,
            speciali, esemplari e consequenziali, inclusi: perdita di profitti,
            perdita di dati o perdita di avviamento; danni informatici; costo di
            prodotti o servizi sostitutivi.
          </p>
          <p>
            La limitazione di responsabilit&agrave; si intende estesa anche ai
            casi in cui Dimot sia informata circa la possibilit&agrave; di
            verificazione di tali danni.
          </p>
          <p>
            I danni cui la limitazione di responsabilit&agrave; si riferisce
            possono derivare: dall&rsquo;uso o abuso del Sito, della Piattaforma
            o dei Servizi, dall&rsquo;impossibilit&agrave; di utilizzare il
            Sito, la Piattaforma o i Servizi o da interruzione, sospensione,
            modifica, alterazione, o cessazione del Sito, della Piattaforma o
            del Servizio.
          </p>
          <p>
            Tale limitazione si applica anche in relazione ai danni subiti a
            causa di altri servizi o prodotti ricevuti attraverso
            pubblicit&agrave; o in connessione con il Sito, la Piattaforma, i
            Servizi o qualsiasi link sul Sito, nonch&eacute; a causa di
            informazioni o consigli ricevuti tramite o pubblicizzati in
            connessione con il Sito, la Piattaforma, i Servizi o qualsiasi link
            sul Sito. Tali limitazioni si applicano nella misura massima
            consentita dalla legge.
          </p>
          <p>
            <strong>Assenza di Garanzia:</strong> I Servizi sono forniti
            &ldquo;cos&igrave; come sono&rdquo; e &ldquo;cos&igrave; come
            disponibili,&rdquo; senza garanzie di alcun tipo, espresse o
            implicite. Il Cliente e l&rsquo;Utente sono in ogni caso tenuti a
            comunicare tempestivamente alla Societ&agrave; ogni eventuale
            difficolt&agrave; riscontrata nell&rsquo;utilizzo della Piattaforma
            o dei Servizi consentendo un efficiente sviluppo e aggiornamento dei
            Servizi.
          </p>

          <h5>11. Manleva</h5>
          <p>
            Il Cliente si impegna a liberare, difendere, manlevare e tenere
            indenne Dimot e i suoi funzionari, direttori, dipendenti da e contro
            qualsiasi pretesa, responsabilit&agrave;, danni, perdite e spese,
            inclusi, senza limitazione, ragionevoli onorari legali e contabili,
            derivanti da, o in qualsiasi modo correlati a:
          </p>
          <ul class="listStyle">
            <li>
              il proprio accesso o utilizzo dei Servizi o dei contenuti o la
              violazione delle presenti Condizioni di Utilizzo da parte degli
              Utenti stessi;
            </li>
            <li>
              i contenuti elaborati, trasmessi, copiati, inviati, messi a
              disposizione dagli Utenti stessi;
            </li>
            <li>violazione dei diritti di terzi.</li>
          </ul>
          <p>
            Dimot si riserva il diritto, a sua esclusiva discrezione, di
            organizzare la difesa con un difensore di propria scelta, avverso
            tutte le rivendicazioni legali, cause legali o di altra natura che
            richiedono una compensazione finanziaria poste in essere da parte
            del Cliente e/o dell&rsquo;Utente, senza che questi ultimi possa
            eccepire alcunch&eacute;.
          </p>

          <h5>
            12. Cancellazione account ed interruzione dell&rsquo;utilizzo della
            Piattaforma
          </h5>
          <p>
            Il Cliente pu&ograve; modificare le Utenze, in qualsiasi momento
            contattando Dimot al seguente indirizzo
            <a href="mailto:dimotma@legalmail.it" target="_blank"
              >dimotma&commat;legalmail.it</a
            >
            .
          </p>
          <p>
            Dimot ha il diritto di sospendere o cancellare ciascuna Utenza per
            violazioni delle presenti Condizioni di Utilizzo o violazione di
            altre nome imperative e in ogni caso in presenza di eventi che
            impediscono la prosecuzione del rapporto tra Dimot e l&rsquo;Utente.
            All&rsquo;esito della cancellazione dell&rsquo;account,
            l&rsquo;Utente perde ogni diritto connesso alle presenti Condizioni
            di Utilizzo e non &egrave; pi&ugrave; legittimato all&rsquo;utilizzo
            dei Servizi.
          </p>
          <p>
            Il Cliente pu&ograve; interrompere l&rsquo;utilizzo dei Servizi
            mediante comunicazione scritta rivolta a Dimot al seguente indirizzo
            <a href="mailto:dimotma@legalmail.it" target="_blank"
              >dimotma&commat;legalmail.it</a
            >
            , nel rispetto del preavviso di 15 (quindici) giorni rispetto al
            mese di fatturazione in corso (i cui pagamenti dovranno essere in
            regola). Al termine del periodo di preavviso, Dimot
            provveder&agrave; alla cancellazione di tutte le Utenze attive ed il
            Cliente e gli Utenti non potranno vantare alcun diritto in relazione
            alle presenti Condizioni di Utilizzo.
          </p>

          <h5>13. Legge Applicabile</h5>
          <p>
            Le presenti Condizioni di Utilizzo sono regolate e interpretate in
            conformit&agrave; con le leggi della Repubblica Italiana.
          </p>
          <p>
            Tutte le controversie riguardanti la validit&agrave;,
            interpretazione o l&rsquo;esecuzione delle presenti Condizioni di
            Utilizzo saranno rimesse alla competenza esclusiva del Foro di Roma.
          </p>

          <h5>14. Contatti</h5>
          <p>
            Qualsiasi comunicazione nei confronti della Societ&agrave;
            dovr&agrave; essere trasmessa ai seguenti indirizzi:
          </p>
          <ul class="listStyle">
            <li>
              Email:
              <a href="mailto:dimotma@legalmail.it" target="_blank"
                >dimotma&commat;legalmail.it</a
              >
            </li>
            <li>
              Indirizzo: Lungotevere De&rsquo; Cenci 10, CAP 00186, ROMA (RM)
            </li>
          </ul>

          <h5>15. Accordo Completo</h5>
          <p>
            Le presenti Condizioni di Utilizzo, congiuntamente
            all&rsquo;Informativa sulla Privacy e ai singoli contratti stipulati
            tra Dimot e il Cliente, disciplinano interamente il rapporto
            contrattuale tra il Cliente, l&rsquo;Utente e Dimot MA S.r.l e
            sostituiscono ogni eventuale precedente accordo, comunicazione o
            dichiarazione, scritti o verbali, intervenuti tra le parti.
          </p>
        </div>

        <!-- Content of English -->
        <div
          id="english"
          role="tabpanel"
          aria-labelledby="english-tab"
          [class.hidden]="activeTab !== 'english'"
        >
          <h3 class="text-[1.2em] my-1 text-dimot-1">Terms and Conditions</h3>
          <p><strong>Effective Date:</strong> 25/03/2025</p>
          <p>
            The website available at the link
            <a href="https://dimotma.com/" target="_blank"
              >https://dimotma.com/</a
            >
            (hereinafter, the &ldquo;Website&rdquo;) and the platform
            (hereinafter, the &ldquo;Platform&rdquo;), which can be accessed
            through the reserved area of the Website, are the exclusive property
            of Dimot Ma S.r.l., with its registered office in Rome (RM),
            Lungotevere De&rsquo; Cenci 10, 00186, VAT No. 17609241009
            (hereinafter, &ldquo;Dimot&rdquo; or the &ldquo;Company&rdquo;).
          </p>

          <h5>1. Acceptance of the Terms</h5>
          <p>
            Anyone who accesses or uses the Services (hereinafter, the
            &ldquo;User&rdquo;), confirms that they have legal capacity within
            their own jurisdiction and accepts these Terms of Use. In the event
            of disagreement with what is stated in these Terms of Use or any
            subsequent amendments, or in the event of dissatisfaction with the
            Services offered by Dimot, the User may choose, respectively, not to
            accept these Terms of Use and to refrain from using the Services
            provided by the Platform.
          </p>

          <h5>2. Description of Services</h5>
          <p>
            Dimot&rsquo;s Services offer solutions to simplify the visualization
            and management of data related to &ldquo;market access&rdquo; of
            companies operating in the life sciences industry (hereinafter, the
            &ldquo;Clients&rdquo;). The Services are accessible through the
            Platform, and the scope and functionality of these Services may be
            updated or modified periodically at the sole discretion of the
            Company.
          </p>

          <h5>3. Platform Operation</h5>
          <p>
            Dimot&rsquo;s Services can be used by accessing the Platform to the
            reserved area. User&rsquo;s access to the Platform is granted
            through the entry of login credentials on the designated page of the
            Website. The login credentials consist of a username and a password,
            both provided by Dimot. After the first login, the User is required
            to change the password previously provided by the Company. It is
            understood that the User is responsible for safeguarding the login
            credentials and for all activities carried out using his account.
          </p>
          <p>
            For subsequent logins, a Multi-Factor Authentication (MFA) procedure
            will be implemented. To access the Platform, the User must enter a
            One-Time Password (OTP) sent to their registered email address.
          </p>
          <p>
            The User must promptly inform Dimot of any unauthorized access to
            his account or any security breach and in any case this
            communication must be done within a term of maximum 48 (forty
            -eight) hours since the breach of the account occurs.
          </p>
          <p>
            Each account is identified by the username and the role held by the
            User within the Client company (hereinafter, &ldquo;Account&rdquo;),
            allowing the use of Services based on the position held.
          </p>
          <p>
            The Platform provides the User with information on the market access
            status of a pharmaceutical product at national level (hereinafter,
            the &ldquo;Product&rdquo;) within the dedicated national dashboard
            (hereinafter, the &ldquo;Dashboard&rdquo;). The addition of one or
            more Products can only be carried out by Dimot.
          </p>
          <p>
            The information displayed on the Dashboard is derived from data
            uploaded by each User into the Platform (hereinafter, the
            &ldquo;Content&rdquo;).
          </p>

          <h5>4. License to Use the Services</h5>
          <p>
            <strong>License Grant:</strong> Dimot grants the Client and the User
            a limited, non-exclusive, non-transferable, and revocable license to
            use the Services solely for business purposes and in compliance with
            these Terms of Use.
          </p>
          <p><strong>Restrictions:</strong> it is prohibited:</p>
          <ul class="listStyle">
            <li>decoding, decompiling, or disassembling the software;</li>
            <li>using the Services for illegal or unauthorized purposes;</li>
            <li>
              modifying, distributing, or creating derivative works from the
              Services without prior written consent from Dimot.
            </li>
          </ul>
          <p>
            Any customization of the Services must be requested in writing to
            Dimot, who is the sole entity authorized to modify the software at
            the base of the Platform.
          </p>

          <h5>5. Payment</h5>
          <p>
            <strong>Fees:</strong> access to Dimot&rsquo;s Platform and Services
            is subject to payment of an initial &ldquo;Set-up &amp;
            Onboarding&rdquo; fee (hereinafter, the &ldquo;Initial Fee&rdquo;),
            which varies depending on the number of Accounts that the Client
            wishes to activate and on the number of Products the Client wishes
            to be displayed on the Dashboards. Pricing and billing details will
            be provided at the time of Services&rsquo; purchase and communicated
            to the Client based on the information provided by the Client to the
            Company.
          </p>
          <p>
            <strong>Billing:</strong> by providing payment details, the Client
            authorizes Dimot to charge the applicable fees on a monthly basis
            within 30 (thirty) days from the issuance of the invoice.
          </p>

          <h5>6. Intellectual Property</h5>
          <p>
            <strong>Ownership:</strong> Dimot MA S.r.l. is the sole owner of all
            content, trademarks, and intellectual property associated with the
            Services.
          </p>
          <p>
            <strong>User Content:</strong> the User declares full and legitimate
            ownership of all rights related to the Content (including, but not
            limited to, copyright, image rights and/or personality rights in
            general, trademark rights and other patent rights, confidentiality
            rights, portrait rights etc.) uploaded to the Company&rsquo;s
            Platform.
          </p>
          <p>
            The User expressly declares that if is not the fully owner the
            Content&rsquo;s rights to the Content uploading to the Platform, he
            has been expressly authorized to dispose of the Content by the
            third-party owners of the aforementioned rights and he is therefore
            fully entitled to release the authorization for the use of Content.
          </p>
          <p>
            The User agrees not to upload Content if such Content and/or its
            use:
          </p>
          <ul class="listStyle">
            <li>
              is false, obscene, pornographic, defamatory, or contains racist,
              violent, offensive, harassing information, or incites criminal
              activities, or is otherwise illegal in Italy or in the place where
              the User uses the Services or under other laws however applicable;
            </li>
            <li>
              violates the rules on the processing of personal data or on the
              protection of trade secrets and confidential information;
            </li>
            <li>
              implies the possession by the User of legal authorizations,
              rights, or qualifications that the User does not possess;
            </li>
            <li>
              infringes patents, trademarks, copyrights, or other third-party
              rights;
            </li>
            <li>
              contains viruses or any program or software designed to o
              interrupt, destroy, damage, or even limit the functionality of any
              software, hardware, or network equipment or of or the Services or
              the Site themselves;
            </li>
          </ul>
          <p>
            The User grants Dimot a worldwide, royalty-free license to use,
            display, and distribute the Content for the Company&rsquo;s
            operational purposes.
          </p>

          <h5>7. Data Privacy</h5>
          <p>
            The User acknowledges to have reviewed Dimot&rsquo;s Privacy Policy
            (https://dimotma.com/privacy/), as amended from time to time; such
            Policy governs the Company&rsquo;s collection and use of
            Users&rsquo; personal data and Content.
          </p>

          <h5>8. Prohibited Activities</h5>
          <p>
            The User guarantees and accepts not to carry out any of the
            following activities:
          </p>
          <ul class="listStyle">
            <li>violate any laws or regulations while using the Services;</li>
            <li>introduce prejudicial code, such as viruses or malware;</li>
            <li>
              interfere with the functionality, integrity, or performance of the
              Services;
            </li>
            <li>misrepresent his identity or affiliation.</li>
          </ul>

          <h5>9. Third-Party Services</h5>
          <p>
            Dimot&rsquo;s Services may incorporate or interact with third-party
            services. The Company assumes no responsibility or liability
            whatsoever for the availability, accuracy, legality, security,
            content, or practices of such third-party services. The Company does
            not endorse or warrant any third-party services, and the User
            acknowledges that any access, interaction, or use of such services
            is entirely at their own risk. Use of third-party services is
            subject exclusively to their respective terms, and the Company shall
            not be held liable for any damages, losses, or issues arising from
            such use.
          </p>

          <h5>10. Limitation of Liability</h5>
          <p>
            In no event shall Dimot be liable for damages to third parties or
            contracting parties arising, directly or indirectly, from the use of
            the Platform or Services, or resulting from any contract entered
            into between the Client, the User, and any third party. This
            exclusion of liability regards, among others, direct, indirect,
            incidental, special, exemplary, and consequential damages, including
            loss of profits, loss of data, or loss of goodwill, computer damage
            or the cost of substitute products or services.
          </p>
          <p>
            The limitation of liability shall also be deemed to be extended to
            cases where Dimot is informed about the possibility of the
            occurrence of such damages.
          </p>
          <p>
            The damages to which the limitation of liability relates may result
            from: the use or improper use of the Site, Platform, or Services;
            the inability to use the Site, the Platform, or the Services; or the
            interruption, suspension, modification, alteration, or termination
            of the Site, Platform, or Services.
          </p>
          <p>
            This limitation also applies with respect to damages incurred as a
            result of other services or products received through advertising or
            in connection with the Site, the Platform, the Services or any link
            on the Site, as well as a result of information or advices received
            through or advertised in connection with the Site, the Platform, the
            Services or any link on the Site.
          </p>
          <p>These limitations apply to the fullest extent permitted by law.</p>
          <p>
            <strong>Disclaimer of Warranties:</strong> The Services are provided
            &ldquo;as is&rdquo; and &ldquo;as available&rdquo; without
            warranties of any kind, express or implied. Clients and Users must
            in any case promptly notify the Company of any difficulties
            encountered in the use of the Platform or the Services, allowing
            efficient development and updating of the Services.
          </p>

          <h5>11. Indemnification</h5>
          <p>
            The Client agrees to release, defend, indemnify, and hold harmless
            Dimot and its officers, directors, managers, employees from and
            against all claims, liabilities, damages, losses, and expenses,
            including, without limitation, reasonable legal and accounting fees,
            arising from, or in any way related to:
          </p>
          <ul class="listStyle">
            <li>
              their own access to or use of the Services or Content, or the
              violation of these Terms of Use;
            </li>
            <li>
              content created, transmitted, copied, sent, or made available by
              Users themselves;
            </li>
            <li>violation of third-party rights.</li>
          </ul>
          <p>
            Dimot reserves the right, at its sole discretion, to arrange its
            defense with a counsel of its own choosing, against all legal
            claims, lawsuits, or other causes of action requiring financial
            compensation brought by the Client and/or the User, without any
            possibility of objection by the latter.
          </p>

          <h5>
            12. Account cancellation and termination of Platform&rsquo;s use
          </h5>
          <p>
            The Client may modify the Accounts at any time by contacting Dimot
            at
            <a href="mailto:dimotma@legalmail.it" target="_blank"
              >dimotma&commat;legalmail.it</a
            >
            .
          </p>
          <p>
            Dimot has the right to suspend or cancel any Account for violations
            of these Terms of Use or other mandatory rules, or, in any case, in
            the presence of events that prevent the continuation of the
            relationship between Dimot and the User. As a result of the account
            cancellation, the User loses all rights under these Terms of Use and
            is no longer entitled to use the Services.
          </p>
          <p>
            The Client may terminate the use of the Services by written
            communication to Dimot at
            <a href="mailto:dimotma@legalmail.it" target="_blank"
              >dimotma&commat;legalmail.it</a
            >
            , subject to 15 (fifteen) days&rsquo; notice before the end of the
            current billing month (up-to date with the payments). Dimot will
            delete all active Accounts at the end of the notice period and the
            Customer and Users shall have no rights with respect to these Terms
            of Use.
          </p>

          <h5>13. Governing Law</h5>
          <p>
            These Terms of Use are governed by and construed in accordance with
            the laws of the Italian Republic.
          </p>
          <p>
            Any disputes regarding the validity, interpretation, or enforcement
            of these Terms shall be referred to the exclusive jurisdiction of
            the Court of Rome.
          </p>

          <h5>14. Contact Information</h5>
          <p>
            All communications towards the Company shall be sent to the
            following addresses:
          </p>
          <ul class="listStyle">
            <li>
              E-mail:
              <a href="mailto:dimotma@legalmail.it" target="_blank"
                >dimotma&commat;legalmail.it</a
              >
            </li>
            <li>
              Address: Lungotevere De&rsquo; Cenci 10, 00186, Rome (RM), Italy
            </li>
          </ul>

          <h5>15. Entire Agreement</h5>
          <p>
            These Terms of Use, together with the Privacy Policy and the
            individual contracts entered into between Dimot and the Client,
            entirely govern the contractual relationship between the Client, the
            User and Dimot and supersede any previous communication or
            statement, written or verbal, intervened between the parties.
          </p>
        </div>
      </div>

      <!-- Checkbox Agreement -->
      <div class="flex items-center mt-10">
        <input
          type="checkbox"
          [disabled]="!canCheck"
          [(ngModel)]="isChecked"
          id="terms"
          class="w-5 h-5 checkboxV text-dimot-2 bg-gray-100 border-gray-300 rounded-sm"
        />

        <label
          [ngClass]="canCheck ? 'text-gray-500' : 'text-gray-200'"
          for="terms"
          class="text-sm ml-2 cursor-pointer"
        >
          Accetto i Termini e le Condizioni e l'Informativa sulla Privacy
        </label>
        <!--<label *ngIf="!canCheck" for="terms" class="text-gray-200 text-sm ml-2">
          Accetto i Termini e le Condizioni e l'Informativa sulla Privacy
        </label>-->
      </div>

      <!-- Continue button -->
      <!-- <button type="button" class="mt-6 w-40 h-9 bg-[#00CEBC] font-sans font-medium rounded-lg text-white hover:bg-[#00b3a4] transition-colors mb-4"
          [disabled]="!isChecked" (click)="acceptTerms()">Continue</button> -->
      <!--INSTEAD FOR NOW-->
      <button
        type="button"
        class="mt-8 w-45 h-11 bg-dimot-2 rounded-xl text-white text-[0.9em] hover:bg-[#00b3a4] transition-colors mb-4"
        [ngClass]="
          isChecked ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'
        "
        [disabled]="!isChecked"
        (click)="acceptTerms()"
      >
        Continue
      </button>
    </div>
  </div>
</section>
